import React, { useState, useContext } from 'react';
import { Form, Input, Button, Row, Col, Card } from 'antd';
import AppLayout from "./components/UserLayout";
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from "./LanguageContext";

const UserForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { language, setLanguage, translations } = useContext(LanguageContext);

  // Form'u başlatırken tüm field'ları tanımlıyoruz,
  // böylece values içinde mutlaka key olarak yer alırlar.
  const initialValues = {
    name: '',
    surname: '',
    email: '',
    password: '',
    companyName: '',
    caravanType: '',
    description: '',
    customerPhone: '',
    customerCountry: ''
  };

  const onFinish = async (values) => {
    // Eğer herhangi bir optional alan gelmediyse,
    // || '' ile boş string'e indirgeriz:
    const payload = {
      name: values.name || '',
      surname: values.surname || '',
      email: values.email,            // required, dolu gelecektir
      password: values.password,      // required
      companyName: values.companyName || '',
      caravanType: values.caravanType || '',
      description: values.description || '',
      customerPhone: values.customerPhone || '',
      customerCountry: values.customerCountry || '',
      role: true
    };

    try {
      const response = await fetch(
        'https://json-configrator-api.root.myoctoopidev.com/User/Create',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error('Kullanıcı oluşturulamadı!');
      }

      const result = await response.json();
      console.log('Kayıt Başarılı:', result);

      form.resetFields();
      navigate('/login');
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  return (
    <AppLayout>
      {/* Bilgilendirme Kutusu */}
      <div style={{
        maxWidth: 900,
        margin: '30px auto',
        backgroundColor: '#f0f2f5',
        padding: '20px 30px',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        fontSize: 16,
        textAlign: 'center',
        color: '#333'
      }}>
        <p style={{ marginBottom: 0 }}>
          {translations[language].sgyö} <strong style={{ color: '#1890ff' }}>{translations[language].kog}</strong><br />
          {translations[language].ehv} <strong style={{ color: '#52c41a' }}>{translations[language].sükgy}</strong>
        </p>
      </div>

      {/* Form Alanı */}
      <Card title={translations[language].kf} style={{ maxWidth: 900, margin: '0 auto' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="name" label={translations[language].name} rules={[{ required: true }]}>
                <Input placeholder={translations[language].name} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="surname" label={translations[language].surname} rules={[{ required: true }]}>
                <Input placeholder={translations[language].surname} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
                <Input placeholder="Email adresinizi girin" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="password" label={translations[language].password} rules={[{ required: true }]}>
                <Input.Password placeholder={translations[language].password} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="companyName" label={translations[language].fa}>
                <Input placeholder={translations[language].fa} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="caravanType" label={translations[language].kt}>
                <Input placeholder={translations[language].kt} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="description" label={translations[language].description}>
                <Input.TextArea placeholder={translations[language].description} rows={3} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="customerPhone" label={translations[language].customerPhone}>
                <Input placeholder={translations[language].customerPhone} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="customerCountry" label={translations[language].country}>
                <Input placeholder={translations[language].country} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ textAlign: 'center', marginTop: '20px' }}>
            <Button 
              type="primary" 
              htmlType="submit" 
              size="large"
            >
              {translations[language].submit}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </AppLayout>
  );
};

export default UserForm;
